import React from "react";
import { Modal, StyleSheet, View, TouchableOpacity, Image } from "react-native";
import Tick from "@assets/svg/RRD/Tick2";
import CustomText from "@components/CustomText";
import { markAction } from "@services/api";
import color from "@constants/color";

const DeliveryInfoModal = ({ visible = true, setVisible, info = {} }) => {
  const closeModal = () => {
    setVisible(false);
  };

  const startDelivery = async () => {
    try {
      closeModal();
      await markAction("order_delivery_info_modal");
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      <Modal
        transparent
        visible={visible}
        onRequestClose={closeModal}
        animationType="slide"
      >
        <View style={styles.modalBackground}>
          <View style={styles.modalContainer}>
            <View style={styles.iconContainer}>
              <Image
                source={{
                  uri: info.icon,
                }}
                style={styles.icon}
                resizeMode="cover"
              />
            </View>
            <View style={styles.container}>
              <CustomText variant="title_18_regular" style={styles.headingText}>
                {info.heading}
              </CustomText>
              <View style={styles.body}>
                {Array.isArray(info.list) &&
                  info.list.map((val) => {
                    const strings = val?.split("$$color");
                    return (
                      <CustomText variant="body_text_1" style={styles.bodyText}>
                        <Tick /> {strings[0]}
                        <CustomText
                          variant="body_text_1"
                          style={[
                            styles.bodyText,
                            {
                              color: "rgba(255, 46, 0, 1)",
                              fontWeight: "700",
                            },
                          ]}
                        >
                          {strings[1]}
                        </CustomText>
                      </CustomText>
                    );
                  })}
              </View>
              {info.is_visible && (
                <TouchableOpacity
                  onPress={startDelivery}
                  style={[
                    styles.button,
                    { backgroundColor: info.button.color },
                  ]}
                >
                  <CustomText
                    style={{ color: info.button.fontColor }}
                    newfont
                    variant="body_text_4"
                  >
                    {info.button.text}
                  </CustomText>
                </TouchableOpacity>
              )}
            </View>
          </View>
        </View>
      </Modal>
    </>
  );
};

export default DeliveryInfoModal;

const styles = StyleSheet.create({
  modalBackground: {
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  modalContainer: {
    backgroundColor: "#fff",
    position: "absolute",
    bottom: 0,
    width: "100%",
    paddingVertical: 20,
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
  },
  icon: {
    height: 160,
    width: 160,
  },
  iconContainer: {
    left: 20,
    bottom: 90,
  },
  container: {
    marginTop: -82,
    marginHorizontal: 20,
  },
  headingText: {
    color: "rgba(0, 0, 0, 0.86)",
    fontSize: 20,
    fontWeight: "700",
  },
  body: {
    top: 20,
  },
  bodyText: {
    color: "rgba(0, 0, 0, 0.86)",
    marginVertical: 12,
  },
  closeIcon: {
    height: 28,
    width: 28,
    backgroundColor: color.lighterBlack,
    borderRadius: 14,
    padding: 6,
    position: "absolute",
    top: 19,
    right: 19,
  },
  button: {
    borderRadius: 8,
    alignItems: "center",
    justifyContent: "center",
    height: 48,
    marginTop: 60,
  },
});
